import React from 'react';
import { HeadingRegular, BodyR } from '@pensionbee/honeypot-ui';
import { CustomerPhoneBookingOption } from '../GuidanceOptions/CustomerPhoneBookingOption';
import { CustomerWebBookingOption } from '../GuidanceOptions/CustomerWebBookingOption';
import { PensionBeeBookingOption } from '../GuidanceOptions/PensionBeeBookingOption';
import { DeclineAppointmentOption } from '../GuidanceOptions/DeclineAppointmentOption';
import { StageProps } from '../../config/StrongerNudgeConfig';

export const GuidanceChoicePartial = ({
  onSubmit,
}: {
  onSubmit: StageProps['onSubmit'];
}) => {
  return (
    <>
      <HeadingRegular className="pb-20">
        You could benefit from guidance or regulated advice
      </HeadingRegular>
      <div className="flex flex-col gap-20 pb-28">
        <BodyR>
          The purpose of guidance is to help you make an informed decision about
          what to do with your pension savings, including the different options
          available to you.
        </BodyR>
        <BodyR>
          The guidance is delivered by Pension Wise, a free government service,
          at an appointment with an independent specialist. You can also obtain
          regulated financial advice at your own cost.
        </BodyR>
      </div>
      <CustomerPhoneBookingOption onSubmit={onSubmit} />
      <CustomerWebBookingOption onSubmit={onSubmit} />
      <PensionBeeBookingOption onSubmit={onSubmit} />
      <DeclineAppointmentOption onSubmit={onSubmit} />
    </>
  );
};
